import { render, staticRenderFns } from "./buildSuccessPage.vue?vue&type=template&id=0c2fb30e&scoped=true"
import script from "./buildSuccessPage.vue?vue&type=script&lang=js"
export * from "./buildSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./buildSuccessPage.vue?vue&type=style&index=0&id=0c2fb30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fb30e",
  null
  
)

export default component.exports